import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Chip, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 500,
    marginBottom: theme.spacing(3),
    '& > * + *': {
      marginTop: theme.spacing(3),
    },
  },
  hidden: {
    display: 'none',
  },
}));

export default function TagSelector({
  label,
  placeholder,
  options,
  value,
  onChange,
  isHidden,
}) {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, isHidden && classes.hidden)}>
      <Autocomplete
        multiple
        value={value}
        onChange={(event, selectedOptions) => onChange(selectedOptions.map((option) => option.value || option))}
        getOptionLabel={(option) => option.label}
        getOptionSelected={(option, selectedValue) => option.value === selectedValue}
        options={options}
        filterSelectedOptions
        renderTags={(tagValue, getTagProps) => Object.values(options)
          .filter((option) => tagValue.includes(option.value))
          .map((option, index) => (
            <Chip variant="outlined" label={option.label} {...getTagProps({ index })} />
          ))}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            placeholder={placeholder}
          />
        )}
      />
    </div>
  );
}
